module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuNTgzMzMgOS4zMzMzM0g3VjdINi40MTY2N003IDQuNjY2NjdINy4wMDU4M00xMi4yNSA3QzEyLjI1IDkuODk5NDkgOS44OTk0OSAxMi4yNSA3IDEyLjI1QzQuMTAwNSAxMi4yNSAxLjc1IDkuODk5NDkgMS43NSA3QzEuNzUgNC4xMDA1IDQuMTAwNSAxLjc1IDcgMS43NUM5Ljg5OTQ5IDEuNzUgMTIuMjUgNC4xMDA1IDEyLjI1IDdaIiBzdHJva2U9IiNGRkYiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/information-circle-2.svg
// module id = adkF
// module chunks = 0